import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ['id', 'startTime', 'endTime', 'amenityType']

  getMaxTimeOptions() {
    if (this.isValidTime(this.startTimeTarget.value) && this.isValidTime(this.endTimeTarget.value)) {
      $.get({
        url: '/amenities/max_time_options',
        data: {
          id: this.idTarget.id,
          start_time: this.startTimeTarget.value,
          end_time: this.endTimeTarget.value
        }
      })
    }
  }

  isValidTime(time) {
    return moment(time, 'h:mm A', true).isValid() && /[AP]M$/.test(time)
  }

  getDuration(e) {
    $('#amenity_reservation_duration').prop('disabled', true)
    const checkinTime = $(e.target).val()

    if (checkinTime) {
      $.get({
        url: this.idTarget.dataset.url,
        data: {
          checkin_time: checkinTime
        }
      })
    }
  }
}